export const country = {
	tr: [
		{ id: 'TR', name: 'Türkiye' },
		{ id: 'VI', name: 'ABD Virgin Adaları' },
		{ id: 'AF', name: 'Afganistan' },
		{ id: 'AX', name: 'Aland Adaları' },
		{ id: 'DE', name: 'Almanya' },
		{ id: 'US', name: 'Amerika Birleşik Devletleri' },
		{ id: 'UM', name: 'Amerika Birleşik Devletleri Küçük Dış Adaları' },
		{ id: 'AS', name: 'Amerikan Samoası' },
		{ id: 'AD', name: 'Andora' },
		{ id: 'AO', name: 'Angola' },
		{ id: 'AI', name: 'Anguilla' },
		{ id: 'AQ', name: 'Antarktika' },
		{ id: 'AG', name: 'Antigua ve Barbuda' },
		{ id: 'AR', name: 'Arjantin' },
		{ id: 'AL', name: 'Arnavutluk' },
		{ id: 'AW', name: 'Aruba' },
		{ id: 'QU', name: 'Avrupa Birliği' },
		{ id: 'AU', name: 'Avustralya' },
		{ id: 'AT', name: 'Avusturya' },
		{ id: 'AZ', name: 'Azerbaycan' },
		{ id: 'BS', name: 'Bahamalar' },
		{ id: 'BH', name: 'Bahreyn' },
		{ id: 'BD', name: 'Bangladeş' },
		{ id: 'BB', name: 'Barbados' },
		{ id: 'EH', name: 'Batı Sahara' },
		{ id: 'BZ', name: 'Belize' },
		{ id: 'BE', name: 'Belçika' },
		{ id: 'BJ', name: 'Benin' },
		{ id: 'BM', name: 'Bermuda' },
		{ id: 'BY', name: 'Beyaz Rusya' },
		{ id: 'BT', name: 'Bhutan' },
		{ id: 'ZZ', name: 'Bilinmeyen veya Geçersiz Bölge' },
		{ id: 'AE', name: 'Birleşik Arap Emirlikleri' },
		{ id: 'GB', name: 'Birleşik Krallık' },
		{ id: 'BO', name: 'Bolivya' },
		{ id: 'BA', name: 'Bosna Hersek' },
		{ id: 'BW', name: 'Botsvana' },
		{ id: 'BV', name: 'Bouvet Adası' },
		{ id: 'BR', name: 'Brezilya' },
		{ id: 'BN', name: 'Brunei' },
		{ id: 'BG', name: 'Bulgaristan' },
		{ id: 'BF', name: 'Burkina Faso' },
		{ id: 'BI', name: 'Burundi' },
		{ id: 'CV', name: 'Cape Verde' },
		{ id: 'GI', name: 'Cebelitarık' },
		{ id: 'DZ', name: 'Cezayir' },
		{ id: 'CX', name: 'Christmas Adası' },
		{ id: 'DJ', name: 'Cibuti' },
		{ id: 'CC', name: 'Cocos Adaları' },
		{ id: 'CK', name: 'Cook Adaları' },
		{ id: 'TD', name: 'Çad' },
		{ id: 'CZ', name: 'Çek Cumhuriyeti' },
		{ id: 'CN', name: 'Çin' },
		{ id: 'DK', name: 'Danimarka' },
		{ id: 'DM', name: 'Dominik' },
		{ id: 'DO', name: 'Dominik Cumhuriyeti' },
		{ id: 'TL', name: 'Doğu Timor' },
		{ id: 'EC', name: 'Ekvator' },
		{ id: 'GQ', name: 'Ekvator Ginesi' },
		{ id: 'SV', name: 'El Salvador' },
		{ id: 'ID', name: 'Endonezya' },
		{ id: 'ER', name: 'Eritre' },
		{ id: 'AM', name: 'Ermenistan' },
		{ id: 'EE', name: 'Estonya' },
		{ id: 'ET', name: 'Etiyopya' },
		{ id: 'FK', name: 'Falkland Adaları (Malvinalar)' },
		{ id: 'FO', name: 'Faroe Adaları' },
		{ id: 'MA', name: 'Fas' },
		{ id: 'FJ', name: 'Fiji' },
		{ id: 'CI', name: 'Fildişi Sahilleri' },
		{ id: 'PH', name: 'Filipinler' },
		{ id: 'PS', name: 'Filistin Bölgesi' },
		{ id: 'FI', name: 'Finlandiya' },
		{ id: 'FR', name: 'Fransa' },
		{ id: 'GF', name: 'Fransız Guyanası' },
		{ id: 'TF', name: 'Fransız Güney Bölgeleri' },
		{ id: 'PF', name: 'Fransız Polinezyası' },
		{ id: 'GA', name: 'Gabon' },
		{ id: 'GM', name: 'Gambia' },
		{ id: 'GH', name: 'Gana' },
		{ id: 'GN', name: 'Gine' },
		{ id: 'GW', name: 'Gine-Bissau' },
		{ id: 'GD', name: 'Granada' },
		{ id: 'GL', name: 'Grönland' },
		{ id: 'GP', name: 'Guadeloupe' },
		{ id: 'GU', name: 'Guam' },
		{ id: 'GT', name: 'Guatemala' },
		{ id: 'GG', name: 'Guernsey' },
		{ id: 'GY', name: 'Guyana' },
		{ id: 'ZA', name: 'Güney Afrika' },
		{ id: 'GS', name: 'Güney Georgia ve Güney Sandwich Adaları' },
		{ id: 'KR', name: 'Güney Kore' },
		{ id: 'CY', name: 'Güney Kıbrıs Rum Kesimi' },
		{ id: 'GE', name: 'Gürcistan' },
		{ id: 'HT', name: 'Haiti' },
		{ id: 'HM', name: 'Heard Adası ve McDonald Adaları' },
		{ id: 'IN', name: 'Hindistan' },
		{ id: 'IO', name: 'Hint Okyanusu İngiliz Bölgesi' },
		{ id: 'NL', name: 'Hollanda' },
		{ id: 'AN', name: 'Hollanda Antilleri' },
		{ id: 'HN', name: 'Honduras' },
		{ id: 'HK', name: 'Hong Kong SAR - Çin' },
		{ id: 'HR', name: 'Hırvatistan' },
		{ id: 'IQ', name: 'Irak' },
		{ id: 'VG', name: 'İngiliz Virgin Adaları' },
		{ id: 'IR', name: 'İran' },
		{ id: 'IE', name: 'İrlanda' },
		{ id: 'ES', name: 'İspanya' },
		{ id: 'IL', name: 'İsrail' },
		{ id: 'SE', name: 'İsveç' },
		{ id: 'CH', name: 'İsviçre' },
		{ id: 'IT', name: 'İtalya' },
		{ id: 'IS', name: 'İzlanda' },
		{ id: 'JM', name: 'Jamaika' },
		{ id: 'JP', name: 'Japonya' },
		{ id: 'JE', name: 'Jersey' },
		{ id: 'KH', name: 'Kamboçya' },
		{ id: 'CM', name: 'Kamerun' },
		{ id: 'CA', name: 'Kanada' },
		{ id: 'ME', name: 'Karadağ' },
		{ id: 'QA', name: 'Katar' },
		{ id: 'KY', name: 'Kayman Adaları' },
		{ id: 'KZ', name: 'Kazakistan' },
		{ id: 'KE', name: 'Kenya' },
		{ id: 'KI', name: 'Kiribati' },
		{ id: 'CO', name: 'Kolombiya' },
		{ id: 'KM', name: 'Komorlar' },
		{ id: 'CG', name: 'Kongo' },
		{ id: 'CD', name: 'Kongo Demokratik Cumhuriyeti' },
		{ id: 'CR', name: 'Kosta Rika' },
		{ id: 'KW', name: 'Kuveyt' },
		{ id: 'KP', name: 'Kuzey Kore' },
		{ id: 'MP', name: 'Kuzey Mariana Adaları' },
		{ id: 'CU', name: 'Küba' },
		{ id: 'KG', name: 'Kırgızistan' },
		{ id: 'LA', name: 'Laos' },
		{ id: 'LS', name: 'Lesotho' },
		{ id: 'LV', name: 'Letonya' },
		{ id: 'LR', name: 'Liberya' },
		{ id: 'LY', name: 'Libya' },
		{ id: 'LI', name: 'Liechtenstein' },
		{ id: 'LT', name: 'Litvanya' },
		{ id: 'LB', name: 'Lübnan' },
		{ id: 'LU', name: 'Lüksemburg' },
		{ id: 'HU', name: 'Macaristan' },
		{ id: 'MG', name: 'Madagaskar' },
		{ id: 'MO', name: 'Makao S.A.R. Çin' },
		{ id: 'MK', name: 'Makedonya' },
		{ id: 'MW', name: 'Malavi' },
		{ id: 'MV', name: 'Maldivler' },
		{ id: 'MY', name: 'Malezya' },
		{ id: 'ML', name: 'Mali' },
		{ id: 'MT', name: 'Malta' },
		{ id: 'IM', name: 'Man Adası' },
		{ id: 'MH', name: 'Marshall Adaları' },
		{ id: 'MQ', name: 'Martinik' },
		{ id: 'MU', name: 'Mauritius' },
		{ id: 'YT', name: 'Mayotte' },
		{ id: 'MX', name: 'Meksika' },
		{ id: 'FM', name: 'Mikronezya Federal Eyaletleri' },
		{ id: 'MD', name: 'Moldovya Cumhuriyeti' },
		{ id: 'MC', name: 'Monako' },
		{ id: 'MS', name: 'Montserrat' },
		{ id: 'MR', name: 'Moritanya' },
		{ id: 'MZ', name: 'Mozambik' },
		{ id: 'MN', name: 'Moğolistan' },
		{ id: 'MM', name: 'Myanmar' },
		{ id: 'EG', name: 'Mısır' },
		{ id: 'NA', name: 'Namibya' },
		{ id: 'NR', name: 'Nauru' },
		{ id: 'NP', name: 'Nepal' },
		{ id: 'NE', name: 'Nijer' },
		{ id: 'NG', name: 'Nijerya' },
		{ id: 'NI', name: 'Nikaragua' },
		{ id: 'NU', name: 'Niue' },
		{ id: 'NF', name: 'Norfolk Adası' },
		{ id: 'NO', name: 'Norveç' },
		{ id: 'CF', name: 'Orta Afrika Cumhuriyeti' },
		{ id: 'UZ', name: 'Özbekistan' },
		{ id: 'PK', name: 'Pakistan' },
		{ id: 'PW', name: 'Palau' },
		{ id: 'PA', name: 'Panama' },
		{ id: 'PG', name: 'Papua Yeni Gine' },
		{ id: 'PY', name: 'Paraguay' },
		{ id: 'PE', name: 'Peru' },
		{ id: 'PN', name: 'Pitcairn' },
		{ id: 'PL', name: 'Polonya' },
		{ id: 'PT', name: 'Portekiz' },
		{ id: 'PR', name: 'Porto Riko' },
		{ id: 'RE', name: 'Reunion' },
		{ id: 'RO', name: 'Romanya' },
		{ id: 'RW', name: 'Ruanda' },
		{ id: 'RU', name: 'Rusya Federasyonu' },
		{ id: 'SH', name: 'Saint Helena' },
		{ id: 'KN', name: 'Saint Kitts ve Nevis' },
		{ id: 'LC', name: 'Saint Lucia' },
		{ id: 'PM', name: 'Saint Pierre ve Miquelon' },
		{ id: 'VC', name: 'Saint Vincent ve Grenadinler' },
		{ id: 'WS', name: 'Samoa' },
		{ id: 'SM', name: 'San Marino' },
		{ id: 'ST', name: 'Sao Tome ve Principe' },
		{ id: 'SN', name: 'Senegal' },
		{ id: 'SC', name: 'Seyşeller' },
		{ id: 'SL', name: 'Sierra Leone' },
		{ id: 'SG', name: 'Singapur' },
		{ id: 'SK', name: 'Slovakya' },
		{ id: 'SI', name: 'Slovenya' },
		{ id: 'SB', name: 'Solomon Adaları' },
		{ id: 'SO', name: 'Somali' },
		{ id: 'LK', name: 'Sri Lanka' },
		{ id: 'SD', name: 'Sudan' },
		{ id: 'SR', name: 'Surinam' },
		{ id: 'SY', name: 'Suriye' },
		{ id: 'SA', name: 'Suudi Arabistan' },
		{ id: 'SJ', name: 'Svalbard ve Jan Mayen' },
		{ id: 'SZ', name: 'Svaziland' },
		{ id: 'RS', name: 'Sırbistan' },
		{ id: 'CS', name: 'Sırbistan-Karadağ' },
		{ id: 'CL', name: 'Şili' },
		{ id: 'TJ', name: 'Tacikistan' },
		{ id: 'TZ', name: 'Tanzanya' },
		{ id: 'TH', name: 'Tayland' },
		{ id: 'TW', name: 'Tayvan' },
		{ id: 'TG', name: 'Togo' },
		{ id: 'TK', name: 'Tokelau' },
		{ id: 'TO', name: 'Tonga' },
		{ id: 'TT', name: 'Trinidad ve Tobago' },
		{ id: 'TN', name: 'Tunus' },
		{ id: 'TC', name: 'Turks ve Caicos Adaları' },
		{ id: 'TV', name: 'Tuvalu' },
		{ id: 'TM', name: 'Türkmenistan' },
		{ id: 'UG', name: 'Uganda' },
		{ id: 'UA', name: 'Ukrayna' },
		{ id: 'OM', name: 'Umman' },
		{ id: 'UY', name: 'Uruguay' },
		{ id: 'QO', name: 'Uzak Okyanusya' },
		{ id: 'JO', name: 'Ürdün' },
		{ id: 'VU', name: 'Vanuatu' },
		{ id: 'VA', name: 'Vatikan' },
		{ id: 'VE', name: 'Venezuela' },
		{ id: 'VN', name: 'Vietnam' },
		{ id: 'WF', name: 'Wallis ve Futuna' },
		{ id: 'YE', name: 'Yemen' },
		{ id: 'NC', name: 'Yeni Kaledonya' },
		{ id: 'NZ', name: 'Yeni Zelanda' },
		{ id: 'GR', name: 'Yunanistan' },
		{ id: 'ZM', name: 'Zambiya' },
		{ id: 'ZW', name: 'Zimbabve' },
	],
	en: [
		{ name: 'Afghanistan', id: 'AF' },
		{ name: 'Åland Islands', id: 'AX' },
		{ name: 'Albania', id: 'AL' },
		{ name: 'Algeria', id: 'DZ' },
		{ name: 'American Samoa', id: 'AS' },
		{ name: 'AndorrA', id: 'AD' },
		{ name: 'Angola', id: 'AO' },
		{ name: 'Anguilla', id: 'AI' },
		{ name: 'Antarctica', id: 'AQ' },
		{ name: 'Antigua and Barbuda', id: 'AG' },
		{ name: 'Argentina', id: 'AR' },
		{ name: 'Armenia', id: 'AM' },
		{ name: 'Aruba', id: 'AW' },
		{ name: 'Australia', id: 'AU' },
		{ name: 'Austria', id: 'AT' },
		{ name: 'Azerbaijan', id: 'AZ' },
		{ name: 'Bahamas', id: 'BS' },
		{ name: 'Bahrain', id: 'BH' },
		{ name: 'Bangladesh', id: 'BD' },
		{ name: 'Barbados', id: 'BB' },
		{ name: 'Belarus', id: 'BY' },
		{ name: 'Belgium', id: 'BE' },
		{ name: 'Belize', id: 'BZ' },
		{ name: 'Benin', id: 'BJ' },
		{ name: 'Bermuda', id: 'BM' },
		{ name: 'Bhutan', id: 'BT' },
		{ name: 'Bolivia', id: 'BO' },
		{ name: 'Bosnia and Herzegovina', id: 'BA' },
		{ name: 'Botswana', id: 'BW' },
		{ name: 'Bouvet Island', id: 'BV' },
		{ name: 'Brazil', id: 'BR' },
		{ name: 'British Indian Ocean Territory', id: 'IO' },
		{ name: 'Brunei Darussalam', id: 'BN' },
		{ name: 'Bulgaria', id: 'BG' },
		{ name: 'Burkina Faso', id: 'BF' },
		{ name: 'Burundi', id: 'BI' },
		{ name: 'Cambodia', id: 'KH' },
		{ name: 'Cameroon', id: 'CM' },
		{ name: 'Canada', id: 'CA' },
		{ name: 'Cape Verde', id: 'CV' },
		{ name: 'Cayman Islands', id: 'KY' },
		{ name: 'Central African Republic', id: 'CF' },
		{ name: 'Chad', id: 'TD' },
		{ name: 'Chile', id: 'CL' },
		{ name: 'China', id: 'CN' },
		{ name: 'Christmas Island', id: 'CX' },
		{ name: 'Cocos (Keeling) Islands', id: 'CC' },
		{ name: 'Colombia', id: 'CO' },
		{ name: 'Comoros', id: 'KM' },
		{ name: 'Congo', id: 'CG' },
		{ name: 'Congo, The Democratic Republic of the', id: 'CD' },
		{ name: 'Cook Islands', id: 'CK' },
		{ name: 'Costa Rica', id: 'CR' },
		{ name: "Cote D'Ivoire", id: 'CI' },
		{ name: 'Croatia', id: 'HR' },
		{ name: 'Cuba', id: 'CU' },
		{ name: 'Cyprus', id: 'CY' },
		{ name: 'Czech Republic', id: 'CZ' },
		{ name: 'Denmark', id: 'DK' },
		{ name: 'Djibouti', id: 'DJ' },
		{ name: 'Dominica', id: 'DM' },
		{ name: 'Dominican Republic', id: 'DO' },
		{ name: 'Ecuador', id: 'EC' },
		{ name: 'Egypt', id: 'EG' },
		{ name: 'El Salvador', id: 'SV' },
		{ name: 'Equatorial Guinea', id: 'GQ' },
		{ name: 'Eritrea', id: 'ER' },
		{ name: 'Estonia', id: 'EE' },
		{ name: 'Ethiopia', id: 'ET' },
		{ name: 'Falkland Islands (Malvinas)', id: 'FK' },
		{ name: 'Faroe Islands', id: 'FO' },
		{ name: 'Fiji', id: 'FJ' },
		{ name: 'Finland', id: 'FI' },
		{ name: 'France', id: 'FR' },
		{ name: 'French Guiana', id: 'GF' },
		{ name: 'French Polynesia', id: 'PF' },
		{ name: 'French Southern Territories', id: 'TF' },
		{ name: 'Gabon', id: 'GA' },
		{ name: 'Gambia', id: 'GM' },
		{ name: 'Georgia', id: 'GE' },
		{ name: 'Germany', id: 'DE' },
		{ name: 'Ghana', id: 'GH' },
		{ name: 'Gibraltar', id: 'GI' },
		{ name: 'Greece', id: 'GR' },
		{ name: 'Greenland', id: 'GL' },
		{ name: 'Grenada', id: 'GD' },
		{ name: 'Guadeloupe', id: 'GP' },
		{ name: 'Guam', id: 'GU' },
		{ name: 'Guatemala', id: 'GT' },
		{ name: 'Guernsey', id: 'GG' },
		{ name: 'Guinea', id: 'GN' },
		{ name: 'Guinea-Bissau', id: 'GW' },
		{ name: 'Guyana', id: 'GY' },
		{ name: 'Haiti', id: 'HT' },
		{ name: 'Heard Island and Mcdonald Islands', id: 'HM' },
		{ name: 'Holy See (Vatican City State)', id: 'VA' },
		{ name: 'Honduras', id: 'HN' },
		{ name: 'Hong Kong', id: 'HK' },
		{ name: 'Hungary', id: 'HU' },
		{ name: 'Iceland', id: 'IS' },
		{ name: 'India', id: 'IN' },
		{ name: 'Indonesia', id: 'ID' },
		{ name: 'Iran, Islamic Republic Of', id: 'IR' },
		{ name: 'Iraq', id: 'IQ' },
		{ name: 'Ireland', id: 'IE' },
		{ name: 'Isle of Man', id: 'IM' },
		{ name: 'Israel', id: 'IL' },
		{ name: 'Italy', id: 'IT' },
		{ name: 'Jamaica', id: 'JM' },
		{ name: 'Japan', id: 'JP' },
		{ name: 'Jersey', id: 'JE' },
		{ name: 'Jordan', id: 'JO' },
		{ name: 'Kazakhstan', id: 'KZ' },
		{ name: 'Kenya', id: 'KE' },
		{ name: 'Kiribati', id: 'KI' },
		{ name: "Korea, Democratic People'S Republic of", id: 'KP' },
		{ name: 'Korea, Republic of', id: 'KR' },
		{ name: 'Kuwait', id: 'KW' },
		{ name: 'Kyrgyzstan', id: 'KG' },
		{ name: "Lao People'S Democratic Republic", id: 'LA' },
		{ name: 'Latvia', id: 'LV' },
		{ name: 'Lebanon', id: 'LB' },
		{ name: 'Lesotho', id: 'LS' },
		{ name: 'Liberia', id: 'LR' },
		{ name: 'Libyan Arab Jamahiriya', id: 'LY' },
		{ name: 'Liechtenstein', id: 'LI' },
		{ name: 'Lithuania', id: 'LT' },
		{ name: 'Luxembourg', id: 'LU' },
		{ name: 'Macao', id: 'MO' },
		{ name: 'Macedonia, The Former Yugoslav Republic of', id: 'MK' },
		{ name: 'Madagascar', id: 'MG' },
		{ name: 'Malawi', id: 'MW' },
		{ name: 'Malaysia', id: 'MY' },
		{ name: 'Maldives', id: 'MV' },
		{ name: 'Mali', id: 'ML' },
		{ name: 'Malta', id: 'MT' },
		{ name: 'Marshall Islands', id: 'MH' },
		{ name: 'Martinique', id: 'MQ' },
		{ name: 'Mauritania', id: 'MR' },
		{ name: 'Mauritius', id: 'MU' },
		{ name: 'Mayotte', id: 'YT' },
		{ name: 'Mexico', id: 'MX' },
		{ name: 'Micronesia, Federated States of', id: 'FM' },
		{ name: 'Moldova, Republic of', id: 'MD' },
		{ name: 'Monaco', id: 'MC' },
		{ name: 'Mongolia', id: 'MN' },
		{ name: 'Montserrat', id: 'MS' },
		{ name: 'Morocco', id: 'MA' },
		{ name: 'Mozambique', id: 'MZ' },
		{ name: 'Myanmar', id: 'MM' },
		{ name: 'Namibia', id: 'NA' },
		{ name: 'Nauru', id: 'NR' },
		{ name: 'Nepal', id: 'NP' },
		{ name: 'Netherlands', id: 'NL' },
		{ name: 'Netherlands Antilles', id: 'AN' },
		{ name: 'New Caledonia', id: 'NC' },
		{ name: 'New Zealand', id: 'NZ' },
		{ name: 'Nicaragua', id: 'NI' },
		{ name: 'Niger', id: 'NE' },
		{ name: 'Nigeria', id: 'NG' },
		{ name: 'Niue', id: 'NU' },
		{ name: 'Norfolk Island', id: 'NF' },
		{ name: 'Northern Mariana Islands', id: 'MP' },
		{ name: 'Norway', id: 'NO' },
		{ name: 'Oman', id: 'OM' },
		{ name: 'Pakistan', id: 'PK' },
		{ name: 'Palau', id: 'PW' },
		{ name: 'Palestinian Territory, Occupied', id: 'PS' },
		{ name: 'Panama', id: 'PA' },
		{ name: 'Papua New Guinea', id: 'PG' },
		{ name: 'Paraguay', id: 'PY' },
		{ name: 'Peru', id: 'PE' },
		{ name: 'Philippines', id: 'PH' },
		{ name: 'Pitcairn', id: 'PN' },
		{ name: 'Poland', id: 'PL' },
		{ name: 'Portugal', id: 'PT' },
		{ name: 'Puerto Rico', id: 'PR' },
		{ name: 'Qatar', id: 'QA' },
		{ name: 'Reunion', id: 'RE' },
		{ name: 'Romania', id: 'RO' },
		{ name: 'Russian Federation', id: 'RU' },
		{ name: 'RWANDA', id: 'RW' },
		{ name: 'Saint Helena', id: 'SH' },
		{ name: 'Saint Kitts and Nevis', id: 'KN' },
		{ name: 'Saint Lucia', id: 'LC' },
		{ name: 'Saint Pierre and Miquelon', id: 'PM' },
		{ name: 'Saint Vincent and the Grenadines', id: 'VC' },
		{ name: 'Samoa', id: 'WS' },
		{ name: 'San Marino', id: 'SM' },
		{ name: 'Sao Tome and Principe', id: 'ST' },
		{ name: 'Saudi Arabia', id: 'SA' },
		{ name: 'Senegal', id: 'SN' },
		{ name: 'Serbia and Montenegro', id: 'CS' },
		{ name: 'Seychelles', id: 'SC' },
		{ name: 'Sierra Leone', id: 'SL' },
		{ name: 'Singapore', id: 'SG' },
		{ name: 'Slovakia', id: 'SK' },
		{ name: 'Slovenia', id: 'SI' },
		{ name: 'Solomon Islands', id: 'SB' },
		{ name: 'Somalia', id: 'SO' },
		{ name: 'South Africa', id: 'ZA' },
		{ name: 'South Georgia and the South Sandwich Islands', id: 'GS' },
		{ name: 'Spain', id: 'ES' },
		{ name: 'Sri Lanka', id: 'LK' },
		{ name: 'Sudan', id: 'SD' },
		{ name: 'Suriname', id: 'SR' },
		{ name: 'Svalbard and Jan Mayen', id: 'SJ' },
		{ name: 'Swaziland', id: 'SZ' },
		{ name: 'Sweden', id: 'SE' },
		{ name: 'Switzerland', id: 'CH' },
		{ name: 'Syrian Arab Republic', id: 'SY' },
		{ name: 'Taiwan, Province of China', id: 'TW' },
		{ name: 'Tajikistan', id: 'TJ' },
		{ name: 'Tanzania, United Republic of', id: 'TZ' },
		{ name: 'Thailand', id: 'TH' },
		{ name: 'Timor-Leste', id: 'TL' },
		{ name: 'Togo', id: 'TG' },
		{ name: 'Tokelau', id: 'TK' },
		{ name: 'Tonga', id: 'TO' },
		{ name: 'Trinidad and Tobago', id: 'TT' },
		{ name: 'Tunisia', id: 'TN' },
		{ name: 'Turkey', id: 'TR' },
		{ name: 'Turkmenistan', id: 'TM' },
		{ name: 'Turks and Caicos Islands', id: 'TC' },
		{ name: 'Tuvalu', id: 'TV' },
		{ name: 'Uganda', id: 'UG' },
		{ name: 'Ukraine', id: 'UA' },
		{ name: 'United Arab Emirates', id: 'AE' },
		{ name: 'United Kingdom', id: 'GB' },
		{ name: 'United States', id: 'US' },
		{ name: 'United States Minor Outlying Islands', id: 'UM' },
		{ name: 'Uruguay', id: 'UY' },
		{ name: 'Uzbekistan', id: 'UZ' },
		{ name: 'Vanuatu', id: 'VU' },
		{ name: 'Venezuela', id: 'VE' },
		{ name: 'Viet Nam', id: 'VN' },
		{ name: 'Virgin Islands, British', id: 'VG' },
		{ name: 'Virgin Islands, U.S.', id: 'VI' },
		{ name: 'Wallis and Futuna', id: 'WF' },
		{ name: 'Western Sahara', id: 'EH' },
		{ name: 'Yemen', id: 'YE' },
		{ name: 'Zambia', id: 'ZM' },
		{ name: 'Zimbabwe', id: 'ZW' },
	],
};
